import { connect } from 'react-redux'

import PartnersAuthInfo from '@cinch/oxd-components/partners-auth-info/src'
import { selectors } from '@cinch/oxd-redux/auth/src'

interface PropsFromState {
  dealerIsAuthenticated: boolean
  dealerName: string
}

export const mapStateToProps = (state: any): PropsFromState => ({
  dealerIsAuthenticated: selectors.isAuthedPartner(state),
  dealerName: state.oidc.user && state.oidc.user.profile.email,
})

export default connect(mapStateToProps)(PartnersAuthInfo)
